import * as React from "react";
import { PresentationContext } from "./PresentationViewWrapper";

export const PresentationViewButton = (props) => {
    return (
        <PresentationContext.Consumer>
            {({ isPresentationView, togglePresentationView }) => {
                return (
                    <>
                        {!isPresentationView && (
                            <button
                                type="button"
                                className="presentation-mode-button"
                                title="Presentation mode"
                                onClick={() => {
                                    if (props.onClick) {
                                        props.onClick();
                                    }
                                    togglePresentationView();
                                }}
                            >
                                <span className="icon" aria-hidden="true"></span>
                                <span className="sr-only">Enter presentation mode of Dashboard</span>
                            </button>
                        )}
                    </>
                );
            }}
        </PresentationContext.Consumer>
    );
};
